import React, { useMemo, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SgSpmError from 'sg-spm-error';
import SgSphError from 'sg-sph-error';
import SgCepError from 'sg-cep-error';
import SgSmiError from 'sg-smi-error';
import SgSptError from 'sg-spt-error';
import CommonConstants from 'sg-common-constants';
import queryString from 'query-string';
import SgCommonError from 'sg-common-error';
import SgBreadcrumbs from 'sg-portals-wizard-react/Wizard/components/sg-breadcrumbs/SgBreadcrumbs';
import SgQnbLobSpecificUtil from 'sg-qnb-lob-specific-util';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import './SgErrorPage.messages';
import { ADOBE_TOPICS, SgProductService } from 'saga-modules';
import { publish } from '@jutro/events';
import styles from './SgErrorPage.module.scss';

function SgErrorPage(props) {
    const { location, history } = props;

    const queryParams = queryString.parse(location.search);
    const quoteIDFromWizard = _.get(location, 'state.gwInfo.params[0].quoteID');
    const quoteIDFromServerCall = _.get(location, 'state.error.gwInfo.params[0].quoteID');
    const effDateFromWizard = _.get(location, 'state.gwInfo.params[0].effectiveDate');
    const effDateFromServerCall = _.get(location, 'state.error.gwInfo.params[0].effectiveDate');
    const errorCodeT = location.state ? _.get(location, 'state.appErrorCode', 4) : Number(queryParams.t);
    const productCode = location.state ? _.get(location, 'state.productCode') : undefined;
    let errorCodeC = location.state ? _.get(location, 'state.baseError.data.appData') : Number(queryParams.c);
    errorCodeC = errorCodeC && errorCodeC.length ? errorCodeC[0] : errorCodeC; // if C code has been passed as array
    const quoteID = quoteIDFromWizard || quoteIDFromServerCall;
    const effectiveDate = effDateFromWizard || effDateFromServerCall;
    const error = _.get(location, 'state');
    const {
        SG_ERROR_CODES
    } = CommonConstants;
    const {
        isMotor,
        isSmi,
        isTravel,
        isHome,
        isQuickQuote
    } = appConfig;

    publish(ADOBE_TOPICS.ERROR_PAGE, { queryString: location.search.substr(location.search.lastIndexOf('?') + 1, location.search.length) });

    const activeBreadcrumb = useMemo(() => {
        return errorCodeT === SG_ERROR_CODES.SAGA_SESSION_TIMEOUT ? 0 : -1;
    }, [SG_ERROR_CODES.SAGA_SESSION_TIMEOUT, errorCodeT]);

    const showLobErrorComponent = useMemo(() => {
        let lobSpecificErrorCodes = [
            SG_ERROR_CODES.SAGA_REFERRAL, // T1
            SG_ERROR_CODES.SAGA_DECLINE, // T0
            SG_ERROR_CODES.SAGA_NON_PURCHASABLE_QUOTE, // T9
            SG_ERROR_CODES.SAGA_POLARIS_REFERRAL
        ];
        const lobSmiSpecificErrorCodes = [
            SG_ERROR_CODES.SAGA_QUOTATION_ERROR, // T6
            SG_ERROR_CODES.BARCLAYCARD_FRAUDULENT_CARD, // T8
            SG_ERROR_CODES.SAGA_PAYMENT_FAILED, // T10
            SG_ERROR_CODES.SAGA_RETRIEVING_AMENDED_OFFLINE, // T13
            SG_ERROR_CODES.SAGA_RETRIEVE_TIA_QUOTE // T17
        ];
        const lobTravelSpecificErrorCodes = [
            SG_ERROR_CODES.SAGA_QUOTATION_ERROR, // T6
            SG_ERROR_CODES.BARCLAYCARD_FRAUDULENT_CARD, // T8
            SG_ERROR_CODES.SAGA_PAYMENT_FAILED, // T10
            SG_ERROR_CODES.SAGA_RETRIEVING_AMENDED_OFFLINE, // T13
            SG_ERROR_CODES.SAGA_RETRIEVE_TIA_QUOTE, // T17
            SG_ERROR_CODES.SAGA_VERISK_EXCEPTION // T19

        ];
        if (isSmi) {
            lobSpecificErrorCodes = [...lobSpecificErrorCodes, ...lobSmiSpecificErrorCodes];
        }
        if (isTravel) {
            lobSpecificErrorCodes = [...lobSpecificErrorCodes, ...lobTravelSpecificErrorCodes];
        }
        return lobSpecificErrorCodes.includes(errorCodeT);
    }, [errorCodeT, SG_ERROR_CODES, isSmi, isTravel]);

    const renderLobError = useCallback(() => {
        if (isHome || SgProductService.isQuickQuoteHome()) {
            return (
                <SgSphError
                    errorCodeT={errorCodeT}
                    errorCodeC={errorCodeC}
                    quoteID={quoteID}
                />
            );
        }
        if (isMotor || SgProductService.isQuickQuoteMotor()) {
            return (
                <SgSpmError
                    errorCodeT={errorCodeT}
                    errorCodeC={errorCodeC}
                    quoteID={quoteID}
                />
            );
        }
        if (isSmi) {
            return (
                <SgSmiError
                    errorCodeT={errorCodeT}
                    errorCodeC={errorCodeC}
                    quoteID={quoteID}
                />
            );
        }
        if (isTravel) {
            return (
                <SgSptError
                    errorCodeT={errorCodeT}
                    errorCodeC={errorCodeC}
                    quoteID={quoteID}
                />
            );
        }
        return <></>;
    }, [errorCodeT, errorCodeC, quoteID, isMotor, isSmi, isTravel, isHome]);

    if (appConfig.isCEP) {
        publish(ADOBE_TOPICS.CONTACT_US_PAGE, error);
        return (
            <SgCepError
                errorCodeT={errorCodeT}
                productCode={productCode}
            />
        );
    }

    return (
        <div className={`${styles.contactUsContainer} sgWizardMainLayout sgErrorPage`}>
            {!isQuickQuote && <SgBreadcrumbs readOnlySteps={SgQnbLobSpecificUtil.getBreadcrubmsSteps()} activeBreadcrumb={activeBreadcrumb} />}
            {
                showLobErrorComponent && renderLobError()
            }
            {
                !showLobErrorComponent
                && (
                    <SgCommonError
                        errorCodeT={errorCodeT}
                        errorCodeC={errorCodeC}
                        quoteID={quoteID}
                        effectiveDate={effectiveDate}
                        location={location}
                        history={history}
                    />
                )
            }
        </div>
    );
}

SgErrorPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            error: PropTypes.shape({
                gwInfo: PropTypes.shape({})
            })
        })
    })
};
SgErrorPage.defaultProps = {
    location: undefined
};
export default withRouter(SgErrorPage);
